import {
  Box,
  Button,
  CircularProgress,
  InputBase,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import ListingDetails from "../../components/lsitingDetail";
import { useDispatch, useSelector } from "react-redux";
import { getSingleArts } from "../../redux/arts/arts.action";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Notifications from "../../components/notification";
import useScrollToTop from "../../components/scrollTop";
import SingleCard from "../../components/card/singleCard";
import { useFormik } from "formik";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  cancelListing,
  putOnFixedPrice,
} from "../../redux/listing/listing.action";
import * as Yup from "yup";
import {
  useCancelDirectListing,
  useChainId,
  useContract,
} from "@thirdweb-dev/react";
const CancelListing = () => {
  const [loading, setLoading] = useState(false);
  const { singleArts } = useSelector((state) => state.arts);
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { marketplaceContract, marketplaceType } = useSelector(
    (state) => state.mint
  );
  const { tokenId, amountId, chainId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const chainid = useChainId();
  const classes = useStyles();
  const { contract: marketplace } = useContract(
    marketplaceContract,
    marketplaceType
  );

  const {
    mutateAsync: cancelDirectListing,
    isLoading,
    error,
  } = useCancelDirectListing(marketplace);

  useScrollToTop();
  useEffect(() => {
    let payload = {
      tokenId,
      amountId,
      chainId,
    };
    dispatch(getSingleArts(payload));
  }, [dispatch, tokenId, amountId, chainId]);
  const handleCancelListing = async () => {
    try {
      setLoading(true);
      // const originalHex = "0x" + singleArts.orderId.toString(16);
      console.log(isLoading, "loading");
      console.log(error, "error");
      const txResult = await cancelDirectListing(singleArts.orderId);
      console.log(txResult, "tx");
      const api = await dispatch(
        cancelListing({
          orderId: singleArts.orderId,
          tokenId: tokenId,
          amountId: amountId,
        })
      );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error.message);
    }
  };
  // useEffect(() => {
  //   if (isPutOnFixPriceSuccess || isPutOnAuctionSuccess) {
  //     setTimeout(() => {
  //       navigate("/");
  //     }, 3000);
  //   }
  // }, [isPutOnFixPriceSuccess, isPutOnAuctionSuccess, navigate]);

  return (
    <>
      <Notifications />
      <Box py={4} sx={{ display: "flex", justifyContent: "space-around" }}>
        <Box sx={{ width: "40%" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            {" "}
            <Typography
              pb={2}
              sx={{ color: "#fff", fontSize: "20px", fontWeight: 600 }}
            >
              Cancel Listing
            </Typography>
            <ErrorOutlineIcon sx={{ color: "white", fontSize: "30px" }} />
          </Box>
          <form>
            <Box>
              <InputBase
                sx={{
                  backgroundColor: "#fff   !important",
                }}
                value={
                  "Current listing price : " + singleArts.fixedPrice + " ETH"
                }
                className={classes.nameInput}
                name="price"
                type="float"
                disabled
              />
            </Box>
            <Box pt={4}>
              {chainid == chainId ? (
                <>
                  {isAuthenticated && (
                    <Button
                      variant="contained"
                      onClick={handleCancelListing}
                      disabled={loading ? true : false}
                      sx={{
                        borderRadius: "2px !important",
                        background: "#1976d2",
                        border: "1.5px solid ##897717",
                        padding: "10px 40px !important",
                        width: "100% !important",
                      }}
                    >
                      {loading ? (
                        <CircularProgress sx={{ color: "#fff" }} />
                      ) : (
                        "Cancel Listing"
                      )}
                    </Button>
                  )}
                </>
              ) : (
                <Typography sx={{ color: "white", fontSize: "18px" }}>
                  To cancel listing,connect your wallet{" "}
                </Typography>
              )}
            </Box>
          </form>
        </Box>
        <Box>
          <SingleCard {...singleArts} />
        </Box>
      </Box>
    </>
  );
};

export default CancelListing;
const validationSchema = Yup.object().shape({
  price: Yup.string().required("Please enter a fix price"),
});
const useStyles = makeStyles((theme) => ({
  nameInput: {
    background: "#1E1C1F",
    color: "#7C7C7C !important",
    fontSize: "18px !important",
    fontWeight: 400 + "!important",
    padding: 10,
    borderRadius: "10px !important",
    width: "100% !important",
  },
}));
